import { useEffect, useState } from "react";
import { useGetAssignmentMarksQuery } from "@features/assignmentMarks/assignmentMarksApi";
import { useGetQuizMarksQuery } from "@features/quizMarks/quizMarksApi";
import useGetUserData from "@common/hooks/useGetUserData";
import LeaderboardList from "@student/components/Leaderboard/LeaderboardList";

const Leaderboard = () => {
  const [selftAssignmentMark, setSelfAssignmentMark] = useState(null);
  const [selftQuizMark, setSelfQuizMark] = useState(null);
  const [selfTotalMark, setSelfTotalMark] = useState(null);

  const { id: userId, name } = useGetUserData();

  const { data: assignmentMarks, isSuccess } =
    useGetAssignmentMarksQuery() || [];

  const { data: quizMarks, isSuccess: isQuizMarkSuccess } =
    useGetQuizMarksQuery() || [];

  useEffect(() => {
    if (isSuccess && isQuizMarkSuccess) {
      const selfAssignmentMarks = assignmentMarks.filter(
        (a) => a.student_id === userId
      );

      const selfQuizMarks = quizMarks.filter((a) => a.student_id === userId);

      const selfTotalAssignmentMark = selfAssignmentMarks.reduce((acc, cur) => {
        return acc + cur.mark;
      }, 0);

      const selfTotalQuizMark = selfQuizMarks.reduce((acc, cur) => {
        return acc + cur.mark;
      }, 0);

      const selfTotalMark = selfTotalAssignmentMark + selfTotalQuizMark;

      setSelfAssignmentMark(selfTotalAssignmentMark);
      setSelfQuizMark(selfTotalQuizMark);
      setSelfTotalMark(selfTotalMark);
    }
  }, [isSuccess, isQuizMarkSuccess, userId, assignmentMarks, quizMarks]);

  return (
    <>
      <div>
        <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
        <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
          <thead>
            <tr>
              <th className="table-th !text-center">Rank</th>
              <th className="table-th !text-center">Name</th>
              <th className="table-th !text-center">Quiz Mark</th>
              <th className="table-th !text-center">Assignment Mark</th>
              <th className="table-th !text-center">Total</th>
            </tr>
          </thead>

          <tbody>
            <tr className="border-2 border-cyan">
              <td className="table-td text-center font-bold">N/A</td>
              <td className="table-td text-center font-bold">{name}</td>
              <td className="table-td text-center font-bold">
                {selftQuizMark}
              </td>
              <td className="table-td text-center font-bold">
                {selftAssignmentMark}
              </td>
              <td className="table-td text-center font-bold">
                {selfTotalMark}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-8">
        <h3 className="text-lg font-bold">Top 20 Result</h3>
        <LeaderboardList
          assignmentMarks={assignmentMarks}
          quizMarks={quizMarks}
        />
      </div>
    </>
  );
};

export default Leaderboard;
